import { Formatter } from '../../shared/models/Formatter';
import formatValue from '../../shared/utils/formatValue';
import { RebootBoxCommand } from '../../site-detail/models/BoxGateway';
import { DeviceMS } from '../../site-detail/models/Device';
import { Execution } from '../../site-detail/models/Execution';
import { UpdateDeviceCommand } from '../../site-detail/models/UpdateDeviceCommand';
import { DeviceEditablePropertyValue } from '../../site-detail/utils/editor-builder/buildEditor';
import { InterventionAction } from '../models/intervention-create-request';
import type { PendingInterventionCreateRequest } from '../models/pending-intervention-create-request';

export function buildPendingDeviceAction(
    device: DeviceMS,
    installerId: string,
    updateTask: Execution,
    sourceCommand: UpdateDeviceCommand,
    valueFormatter: Formatter | undefined,
): PendingInterventionCreateRequest {
    return {
        ...buildPendingActionBase(device, installerId, updateTask, sourceCommand),
        action: InterventionAction.UPDATE_DEVICE,
        data: {
            attribute: sourceCommand.property.label,
            value: formatValue(sourceCommand.newValue as DeviceEditablePropertyValue, valueFormatter),
            queued: false,
            translateValue: valueFormatter?.type === 'named-value',
        },
    };
}

export function buildPendingRebootAction(
    device: DeviceMS,
    installerId: string,
    updateTask: Execution,
    sourceCommand: RebootBoxCommand,
): PendingInterventionCreateRequest {
    return {
        ...buildPendingActionBase(device, installerId, updateTask, sourceCommand),
        action: InterventionAction.REBOOT_GATEWAY,
        data: {
            attribute: 'BOX_REBOOT',
            queued: false,
            translateValue: false,
        },
    };
}

function buildPendingActionBase(
    device: DeviceMS,
    installerId: string,
    updateTask: Execution,
    sourceCommand: UpdateDeviceCommand | RebootBoxCommand,
): Omit<PendingInterventionCreateRequest, 'data' | 'action'> {
    return {
        job_id: updateTask.job_id,
        id_device: device.id,
        id_session: sourceCommand.sessionId,
        device_url: device.deviceurl,
        id_installer: installerId,
        id_site: sourceCommand.device.site_id,
    };
}
